import React, { Component } from 'react';
import { Modal, Button, Select, Input, message } from 'antd';
import { getMatchOption } from '../../shared/selectFn';
import Text from '../../basicElement/Text';
import ContentList from '../../basicElement/ContentList';

const { Option } = Select;

const cooperationTypeList = [
    { label: 'CRO', value: 'CRO' },
    { label: '申办方', value: 'SPONSOR' }, 
    { label: '第三方实验室', value: 'FQT' },
    { label: '其他', value: 'OTHER' },
];

class AddCooperationUnit extends Component {
    state = {
        visible: false,
        params: {},
        data: [],
    }

    show = (data) => {
        this.setState({
            data: data || [],
            visible: true,
        });
    }

    hide = () => {
        this.setState({
            visible: false,
            params: {},
            data: [],
        });
    }

    handleChange = (value, key) => {
        const { params } = this.state;
        switch (key) {
            case 'cooperationType': {
                params[key] = value;
                params.cooperationTypeValue = getMatchOption(cooperationTypeList, 'value', value).label;
                params.cooperationOtherRemark = undefined;
            }
            default:
                params[key] = value;
        }
        this.setState({ params });
    }

    handleAdd = () => {
        const { params, data } = this.state;
        const { constitutionName, cooperationType, cooperationOtherRemark } = params;
        let msg;
        switch(true) {
            case !constitutionName:
                msg = '请输入合作单位';
                break;
            case !cooperationType:
                msg = '请选择合作单位类别';
                break;
            case (cooperationType === 'OTHER' && !cooperationOtherRemark):
                msg = '请补充其他说明';
                break;
        }
        if (msg) {
            message.warning(msg);
            return;
        }

        data.push({...params});
        this.setState({
            data,
            params: {},
        });
    }

    handleRemove = (index) => {
        const { data } = this.state;
        data.splice(index, 1);
        this.setState({ data });
    }

    confirm = () => {
        this.props.onChange(this.state.data, 'cooperationList');
        this.hide();
    }

    render() {
        const { visible, params, data } = this.state;
        const cooperationTypeOption = cooperationTypeList.map(i => <Option key={i.value}>{i.label}</Option>);
        return (
            <Modal
                title="添加合作单位"
                visible={visible}
                onCancel={this.hide}
                onOk={this.confirm}
                className="preview-modal"
                width="500px"
            >
                <div className="field">
                    <div className="field-form">
                        <div className="field-list">
                            <div className="field-item">
                                <span className="field-label" style={{width: 100}}><Text asterisk={true} colon={true}>合作单位</Text></span>
                                <div className="field-value">
                                    <Input
                                        maxLength='200'
                                        placeholder="请输入"
                                        value={params.constitutionName}
                                        onChange={e => this.handleChange(e.target.value, 'constitutionName')}
                                    />
                                </div>
                            </div>
                            <div className="field-item">
                                <span className="field-label" style={{width: 100}}><Text asterisk={true} colon={true}>合作单位类别</Text></span>
                                <div className="field-value">
                                    <Select
                                        placeholder="请选择"
                                        style={{ width: '100%' }}
                                        value={params.cooperationType}
                                        onChange={value => this.handleChange(value, 'cooperationType')}
                                        allowClear={true}
                                    >
                                        {cooperationTypeOption}
                                    </Select>
                                </div>
                            </div>
                            {
                                params.cooperationType === 'OTHER' &&
                                <div className="field-item">
                                    <span className="field-label" style={{width: 100}}></span>
                                    <div className="field-value">
                                        <Input
                                            maxLength='200'
                                            placeholder="补充其他说明"
                                            value={params.cooperationOtherRemark}
                                            onChange={e => this.handleChange(e.target.value, 'cooperationOtherRemark')}
                                        />
                                    </div>
                                </div>
                            }
                        </div>
                        <div  className="field-button">
                            <Button type="primary" onClick={this.handleAdd}>添加</Button>
                        </div>
                    </div>
                    <ContentList
                        data={data}
                        onRemove={this.handleRemove}
                        render={item => {
                            const { constitutionName, cooperationTypeValue, cooperationOtherRemark } = item;
                            return `${constitutionName}(${cooperationTypeValue}${cooperationOtherRemark ? `-${cooperationOtherRemark}` : ''})`;
                        }}
                    />
                </div>
            </Modal>
        );
    }
}

export default AddCooperationUnit;


// WEBPACK FOOTER //
// ./src/components/invStartUp/heredity/AddCooperationUnit.js